import { render, staticRenderFns } from "./CtbUser.vue?vue&type=template&id=570b89d8&"
import script from "./CtbUser.vue?vue&type=script&lang=js&"
export * from "./CtbUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports